import { george, observer, React, ui } from "aaa";
import { LimitsStore } from "stores/LimitsStore";
import * as amount from "types/amount";
import trackingStore from "stores/TrackingStore";

const ChooseLimitDropdown = observer((props: {
    store: LimitsStore,
    isSalaryAdvance?: boolean
}) => {
    let limits: { value: string, label: string }[] = [];
    const limitsStore = props.store.cardLimits;
    const selectedLimit = props.store.selectedLimit;
    if (limitsStore && limitsStore.limits.length > 0) {
        if (props.isSalaryAdvance === true && selectedLimit) {
            limits.push({ value: selectedLimit.shortCode, label: amount.amountToCurrencyString(selectedLimit.limit) });
        } else {
            limits = limitsStore.limits.map(entry => {
                return {
                    value: entry.shortCode,
                    label: amount.amountToCurrencyString(entry.limit)
                };
            });
        }
    }

    return (
        <george.DropDown
            isLoading={props.store.isLoading}
            disabled={props.isSalaryAdvance}
            value={props.store.selectedLimitShortCode}
            onChange={async (event: any, index: number, value: string) => {
                await trackingStore.trackEvent({ eventName: "limitSet" });
                props.store.selectedLimitShortCode = value;
            }}
            aria-label={ui.__("a11y.chooseAmount")}
            items={limits}
        />
    );
});

export const ChooseLimitEmbedded = observer((props: {
    store: LimitsStore,
    infoSubtitle: string,
    isSalaryAdvance?: boolean
}) => (
        <>
            <george.SectionTitle style={{ marginTop: 0 }}>
                {props.isSalaryAdvance === true ? ui.__("shop.cardInfo.limit.title.salaryAdvance") : ui.__("shop.cardInfo.limit.title")}
            </george.SectionTitle>
            <george.SectionSubtitleTop>
                {props.infoSubtitle}
            </george.SectionSubtitleTop>
            <ChooseLimitDropdown store={props.store} isSalaryAdvance={props.isSalaryAdvance} />
        </>
    ));

export const ChooseLimit = observer((props: {
    store: LimitsStore,
    infoSubtitle: string,
    isSalaryAdvance?: boolean
}) => (
        <george.Card>
            <george.CardSectionTitle title={props.isSalaryAdvance === true ? ui.__("shop.cardInfo.limit.title.salaryAdvance") : ui.__("shop.cardInfo.limit.title")} />

            <george.CardSectionContent>
                <george.SectionSubtitleTop>
                    {props.infoSubtitle}
                </george.SectionSubtitleTop>
                <ChooseLimitDropdown store={props.store} isSalaryAdvance={props.isSalaryAdvance} />
            </george.CardSectionContent>
        </george.Card >
    ));

export const ChooseLimitResponsive = observer(({
    store,
    description,
    isSalaryAdvance,
}: {
    store: LimitsStore,
    description: string,
    isSalaryAdvance?: boolean
}) => (
        <>
            {description &&
                <>
                    <george.SectionTitle style={{ marginTop: 0 }}>
                        {isSalaryAdvance ? ui.__("shop.cardInfo.limit.title.salaryAdvance") : ui.__("shop.cardInfo.limit.title")}
                    </george.SectionTitle>
                    <george.SectionSubtitleTop>
                        {description}
                    </george.SectionSubtitleTop>
                </>
            }
            <george.ResponsiveFormElement label={ui.__("common.cardlimit")}>
                <ChooseLimitDropdown store={store} isSalaryAdvance={isSalaryAdvance} />
            </george.ResponsiveFormElement>
        </>
    ));


// WEBPACK FOOTER //
// ./src/components/common/ChooseLimit.tsx